import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-best-learning-management-system-india',
  templateUrl: './best-learning-management-system-india.component.html',
  styleUrls: ['./best-learning-management-system-india.component.scss']
})
export class BestLearningManagementSystemIndiaComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Best LMS in India | Learning Management System | VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Explore VIRSA LMS for AI-powered learning assistance, digital learning, assessments and institutional academic workflows for schools and colleges in India.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'Best Learning Management System in India, Best LMS Providers in India, Best LMS Software in India, Learning Management System India, LMS for Schools in India, LMS for Colleges and Universities, AI-Powered LMS, Digital Learning Management System, Education LMS Software, LMS Company in India, VIRSA Learning Management System, VIRSA LMS'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
